import React, {Suspense} from 'react'; 
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'; 
import routes from './routes' 
import routesAuth from './routesAuth' 
import 'antd/dist/antd.css'; 
import './assets/scss/global.scss';   
import './assets/scss/cropper.scss';  
import 'react-phone-number-input/style.css' 
import { getPersonalData } from './data/API'
import { useDispatch } from "react-redux";
import { Spin, Space } from 'antd'; 

function App() {

  const dispatch = useDispatch(); 
  const authDetailsRefresh = () => { 
    getPersonalData().then((res) => {
        localStorage.setItem('doctor_user_details', JSON.stringify(res.data.doctor)) 
        dispatch({
                type: "SIGN_IN",
                payload: res.data.doctor
        }) 
    }).catch((error) =>  console.log(error)) 
  }
  
  
  return ( 
          <Suspense fallback={
            <Space size="middle" className='custom-ant-spinner'> 
                <Spin size="large" />
          </Space>
             }>
            <Router>  
              <Switch>
                
                 {/* auth routes */}
              {routesAuth.map((route, index) => {
                return (
                  <Route
                    key={index}
                    path={route.path}
                    exact={route.exact}
                    component={(props => { 
                      let auth = localStorage.getItem('doctor_jwt_token');
                      if(!auth){
                          return (
                            <route.layout {...props}>
                              <route.component {...props} />
                            </route.layout>
                          );
                      }else{
                        return (
                          <Redirect
                            to={{
                              pathname: "/dashboard", 
                            }}
                          />
                        )
                      } 
                    })}
                  />
                );
              })}

            {routes.map((route, index) => {
              return ( 
                <Route
                  key={index}
                  path={route.path}
                  exact={route.exact}
                  component={(props => { 
                    let auth = localStorage.getItem('doctor_jwt_token');
                    if(auth){
                       authDetailsRefresh()
                        return (
                          <route.layout {...props}>
                            <route.component {...props} />
                          </route.layout>
                        );
                    }else{
                      return (
                        <Redirect
                          to={{
                            pathname: "/", 
                          }}
                        />
                      )
                    } 
                  })}
                />

              );
            })}
              </Switch>  
        </Router> 
        </Suspense>
  
  );
}

export default App;
